var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThulabharam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.44 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#699;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M13.51,50c.22-1.46,1.26-1.68,2.32-1.72,1.94-.06,3.88,.01,5.82-.05,.42-.01,.82-.36,1.24-.54,.58-.26,1.15-.66,1.76-.74,4.2-.53,6.32-2.84,6.32-7.03,0-9.04,0-18.09,0-27.13,0-1.69-.56-2.29-2.18-1.91-2.56,.61-5.06,1.41-7.59,2.13-1.9,.54-3.78,1.13-5.7,1.56-.84,.19-1.8-.14-2.65,.04-.82,.18-1.43-.4-2.31-.44v21.12h-.18c0-4.54,0-15.59,0-20.13,0-.71-.03-1.23-.93-1.43-.6-.14-1.14-.65-1.63-1.07-1.11-.95-1.32-2.28-.58-3.31,.83-1.16,2.71-1.58,3.86-.86,1.3,.81,1.25,2.01-.32,3.19,.42,.26,.74,.56,1.12,.67,2.05,.6,4.08,.41,6.06-.29,2.41-.85,4.79-1.82,7.22-2.59,1.36-.43,2.79-.63,4.21-.85,1.1-.17,1.66-.71,1.6-1.84-.03-.7-.06-1.37,.65-1.85,.17-.12,.2-.67,.08-.91-1.01-2.02-1-2.15,.77-4,.4,.58,.98,1.09,1.14,1.71,.15,.58-.15,1.27-.25,1.91-.07,.44-.34,1.15-.18,1.27,.75,.54,.65,1.26,.64,1.98-.01,.95,.42,1.59,1.37,1.67,3.22,.27,6.17,1.46,9.14,2.6,2.28,.88,4.57,1.82,7.09,1.48,.86-.12,1.69-.44,2.71-.72-1.53-1.46-1.69-2.09-.96-2.96,.85-1.02,2.59-1.1,3.81-.18,1.1,.83,1.41,2.25,.53,3.27-.61,.71-1.43,1.35-2.29,1.71-.72,.3-.81,.67-.81,1.29,.01,4.58,0,15.68-.12,20.26V14.3c-.28-.03-.47-.09-.63-.05-2.6,.65-4.38,.63-7.22-.26-2.03-.64-4.01-1.46-6.04-2.09-1.48-.45-3-.78-4.52-1.05-1.5-.26-2.07,.29-2.07,1.82,0,7.84,0,15.68,0,23.52,0,1.44-.01,2.87,0,4.31,.05,3.43,2.34,5.99,5.73,6.38,1,.12,2.02,.11,2.61,1.19,.1,.18,.63,.18,.96,.19,1.94,.02,3.88-.03,5.82,.03,1.06,.03,2.09,.26,2.32,1.72H13.51ZM9.6,9.87l1.11,.78,.43-.7c-.37-.21-.79-.65-1.09-.57-.43,.11-1.05,.56-1.08,.92-.04,.39,.49,.84,.78,1.26l.25-.21c-.28-.5-1.23-.95-.4-1.48Zm45.14,1.5l.22,.2c.29-.36,.71-.68,.84-1.09,.08-.24-.22-.78-.48-.91-.37-.18-.87-.18-1.29-.1-.17,.03-.34,.46-.37,.73-.02,.13,.29,.43,.41,.42,.26-.04,.51-.21,.72-.39,.09-.08,.04-.31,.07-.59,1.09,.78,.16,1.22-.11,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44.02,34.98h20.43c-3.07,4.12-15.81,4.18-20.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,34.95H20.72c-4.31,3.6-14.08,4.86-20.72,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 9.32,
    y1: 13.8,
    x2: 1.64,
    y2: 34.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 11.65,
    y1: 13.8,
    x2: 19.34,
    y2: 34.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 53.11,
    y1: 13.8,
    x2: 45.42,
    y2: 34.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 55.44,
    y1: 13.8,
    x2: 63.13,
    y2: 34.99
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThulabharam);
export default __webpack_public_path__ + "static/media/Thulabharam.aef0ec7de02c5eda2b2c01b12d2149a1.svg";
export { ForwardRef as ReactComponent };